import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { initials, memberLabel } from '../community-format';

/** One space in the sidebar list (presentation only; the host handles clicks). */
@Component({
  selector: 'app-cm-space-row',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="cm-av" aria-hidden="true">
      <img *ngIf="avatarUrl; else ini" [src]="avatarUrl" alt="" />
      <ng-template #ini>{{ initialsText }}</ng-template>
    </span>
    <span class="cm-name" [title]="name">{{ name }}</span>
    <i *ngIf="pending" class="fa fa-clock-o cm-pending" title="Request pending" aria-label="Request pending"></i>
    <span *ngIf="members > 0" class="cm-count">{{ membersText }}</span>
    <span *ngIf="unread > 0" class="cm-unread">{{ unread > 99 ? '99+' : unread }}</span>
  `,
  styles: [`
    :host { display: flex; align-items: center; gap: 10px; min-width: 0; width: 100%; }
    .cm-av {
      width: 28px; height: 28px; flex: none; display: grid; place-items: center; overflow: hidden;
      border-radius: var(--cm-shape); background: var(--cm-sec-bg); color: var(--cm-sec-fg);
      font-size: 11px; font-weight: 700;
    }
    .cm-av img { width: 100%; height: 100%; object-fit: cover; background: #fff; }
    .cm-name { flex: 1; min-width: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .cm-pending { opacity: 0.7; }
    .cm-count { font-size: 12px; opacity: 0.7; white-space: nowrap; font-variant-numeric: tabular-nums; }
    .cm-unread {
      min-width: 20px; height: 20px; padding: 0 6px; border-radius: 10px; text-align: center;
      font-size: 11px; font-weight: 700; line-height: 20px;
      background: var(--cm-nav-accent); color: var(--cm-nav-bg);
    }
  `],
})
export class CmSpaceRowComponent {
  @Input() name = '';
  @Input() avatarUrl: string | null = null;
  @Input() unread = 0;
  @Input() members = 0;
  @Input() pending = false;

  get initialsText(): string {
    return initials(this.name);
  }

  get membersText(): string {
    return memberLabel(this.members);
  }
}
